// import { Button, Container, Notifications, Text } from "@jds/core";
// import { useCallback, useEffect, useRef, useState } from "react";
// import { Alert, Box, Snackbar } from "@mui/material";
// import Webcam from "react-webcam";

// import EventRegistrationPrimaryBtn from "../EventRegistrationPrimaryBtn/EventRegistrationPrimaryBtn";
// import EventRegistrationSecondaryBtn from "../EventRegistrationSecondaryBtn/EventRegistrationSecondaryBtn";
// import useApiHttp from "../../../hooks/use-http";
// import { useNavigate } from "react-router-dom";
// import { useDispatch, useSelector } from "react-redux";
// import {
//   setSelfieModalClose,
//   setUserClusterApiTrigger,
// } from "../../../store/state-slices/userRegistration";

// import * as faceapi from "face-api.js";
// import ImageCam from "../ImageCam/ImageCam";

// const detectAndCropLargestFace = async (imageFile) => {
//   const img = await faceapi.bufferToImage(imageFile);

//   // Draw the image onto a canvas
//   const canvas = document.createElement("canvas");
//   canvas.width = img.width;
//   canvas.height = img.height;
//   const ctx = canvas.getContext("2d");
//   ctx.drawImage(img, 0, 0);

//   // Detect faces with landmarks and descriptors
//   const detections = await faceapi
//     .detectAllFaces(canvas)
//     .withFaceLandmarks()
//     .withFaceDescriptors();

//   if (!detections.length) {
//     throw new Error("No face detected.");
//   }

//   // Find the largest face
//   const largest = detections.reduce((max, det) => {
//     const area = det.detection.box.width * det.detection.box.height;
//     const maxArea = max.detection.box.width * max.detection.box.height;
//     return area > maxArea ? det : max;
//   });

//   const { x, y, width, height } = largest.detection.box;

//   // Adjusted padding
//   const sidePadding = Math.floor(width * 0.2); // Increase width by 30% on each side
//   const topPadding = Math.floor(height * 0.5); // Increase height above face for hair
//   const bottomPadding = Math.floor(height * 0.2); // Slight bottom padding

//   const paddedX = Math.max(0, x - sidePadding);
//   const paddedY = Math.max(0, y - topPadding);
//   const paddedWidth = Math.min(canvas.width - paddedX, width + 2 * sidePadding);
//   const paddedHeight = Math.min(
//     canvas.height - paddedY,
//     height + topPadding + bottomPadding
//   );

//   // Optional: Create a preview with a red rectangle
//   const previewCanvas = document.createElement("canvas");
//   previewCanvas.width = canvas.width;
//   previewCanvas.height = canvas.height;
//   const previewCtx = previewCanvas.getContext("2d");
//   previewCtx.drawImage(img, 0, 0);
//   previewCtx.strokeStyle = "yellow";
//   previewCtx.lineWidth = 3;
//   previewCtx.strokeRect(paddedX, paddedY, paddedWidth, paddedHeight);

//   const previewUrl = previewCanvas.toDataURL();

//   // Create the cropped image with expanded bounding box
//   const faceCanvas = document.createElement("canvas");
//   faceCanvas.width = paddedWidth;
//   faceCanvas.height = paddedHeight;
//   const faceCtx = faceCanvas.getContext("2d");
//   faceCtx.drawImage(
//     img,
//     paddedX,
//     paddedY,
//     paddedWidth,
//     paddedHeight,
//     0,
//     0,
//     paddedWidth,
//     paddedHeight
//   );

//   // Return result
//   return new Promise((resolve) => {
//     faceCanvas.toBlob((blob) => {
//       const croppedFile = new File([blob], imageFile.name, {
//         type: imageFile.type,
//       });
//       resolve({
//         blobUrl: URL.createObjectURL(blob),
//         file: croppedFile,
//         previewUrl,
//       });
//     }, imageFile.type);
//   });
// };

// const Selfie = ({
//   setToastOpen = () => { },
//   setToastInfo = () => { },
//   isGetFile = false,
//   getFile = () => { },
// }) => {
//   const webcamRef = useRef(null);
//   const navigate = useNavigate();
//   const dispatch = useDispatch();
//   const [fileBlob, setFileBlod] = useState(null);
//   const [previewUrl, setPreviewUrl] = useState(null);
//   const [userSelectedFile, setUserSelectedFile] = useState(null);
//   const [isWebcamReady, setIsWebcamReady] = useState(false);
//   const [btnDisable, setBtnDisable] = useState(false);
//   const [isDetectingFace, setIsDetectingFace] = useState(false);
//   const [isCropped, setIsCropped] = useState(false);
//   const loginDetails = useSelector((state) => state.auth.loginDetails)

//   const { sendRequest: updateProfile, isLoading: isProfileUpdating } =
//     useApiHttp();
//   const { sendRequest: getFaceCount, isLoading: isGetFaceCounting } =
//     useApiHttp();

//   const capturePhoto = useCallback(() => {
//     const imageSrc = webcamRef.current.getScreenshot();
//     let currentDate = new Date();
//     let dateTimeString =
//       currentDate.getFullYear() +
//       String(currentDate.getMonth() + 1).padStart(2, "0") +
//       String(currentDate.getDate()).padStart(2, "0") +
//       "T" +
//       String(currentDate.getHours()).padStart(2, "0") +
//       String(currentDate.getMinutes()).padStart(2, "0") +
//       String(currentDate.getSeconds()).padStart(2, "0") +
//       ".jpg";
//     return dataURItoFile(imageSrc, dateTimeString);
//   }, [webcamRef]);

//   function dataURItoFile(dataURI, filename) {
//     var byteString = atob(dataURI.split(",")[1]);
//     var mimeString = dataURI.split(",")[0].split(":")[1].split(";")[0];
//     var ia = new Uint8Array(byteString.length);
//     for (var i = 0; i < byteString.length; i++) {
//       ia[i] = byteString.charCodeAt(i);
//     }
//     return new File([ia], filename, { type: mimeString });
//   }

//   async function profileCapture(imgFile) {
//     try {
//       setIsDetectingFace(true);
//       const { blobUrl, file, previewUrl } = await detectAndCropLargestFace(
//         imgFile
//       );
//       setFileBlod(blobUrl);
//       setUserSelectedFile(file);
//       setPreviewUrl(previewUrl);
//       setIsCropped(false);
//     } catch (err) {
//       // Notifications.toast.error({
//       //   id: "face-detection-failure",
//       //   title: err.message || "Unable to detect face. Try again.",
//       // });
//       setToastInfo({
//         msg: err.message || "Unable to detect face. Try again.",
//         type: "error",
//       });
//       setToastOpen(true);
//     } finally {
//       setIsDetectingFace(false);
//     }
//   }

//   const handleUserMedia = () => setIsWebcamReady(true);

//   const resetSelfie = () => {
//     setFileBlod(null);
//     setUserSelectedFile(null);
//     setIsWebcamReady(false);
//     setPreviewUrl(null);
//     setIsCropped(false);
//   }

//   const handleUpdateSelfie = () => {
//     if (!userSelectedFile) return;
//     const userProfile = new FormData();
//     userProfile.append("profilePicture", userSelectedFile);
//     updateProfile(
//       {
//         base: "AUTH",
//         url: `profile`,
//         method: "PUT",
//         body: userProfile,
//         formData: true,
//       },
//       null,
//       (data) => {
//         setTimeout(() => {
//           // Notifications.toast.success({
//           //   id: "update-profile",
//           //   title: data?.message,
//           // });
//           setToastInfo({
//             msg: data?.message,
//             type: "success",
//           });
//           setToastOpen(true);
//           localStorage.profilePictureThumbnail =
//             data?.data?.profilePictureThumbnailUrl;
//           dispatch(setSelfieModalClose(true));
//           dispatch(setUserClusterApiTrigger());
//           navigate(`/user-registered/photos?eventId=${loginDetails?.eventId}`);
//           setBtnDisable(false);

//           resetSelfie()
//         }, 2000);
//       },
//       (err, data) => {
//         // Notifications.toast.error({
//         //   id: "update-profile",
//         //   title: data?.message,
//         // });
//         setToastInfo({
//           msg: data?.message,
//           type: "error",
//         });
//         setToastOpen(true);
//         setBtnDisable(false);
//       }
//     );
//   };

//   const handleGetFaceCount = () => {
//     if (!userSelectedFile) return;
//     const userProfile = new FormData();
//     userProfile.append("uploadFile", userSelectedFile);
//     getFaceCount(
//       {
//         base: "MEDIA",
//         url: `face/get-face-count`,
//         method: "POST",
//         body: userProfile,
//         formData: true,
//       },
//       null,
//       () => {
//         if (isGetFile) {
//           getFile(userSelectedFile);
//         } else {
//           setBtnDisable(true);
//           handleUpdateSelfie();
//         }
//       },
//       (err, data) => {
//         // Notifications.toast.error({
//         //   id: "get-face-count-error",
//         //   title: data?.message,
//         // });

//         setToastInfo({
//           msg: data?.message,
//           type: "error",
//         });
//         setToastOpen(true);
//       }
//     );
//   };

//   useEffect(() => {
//     const loadModels = async () => {
//       // const MODEL_URL = process.env.REACT_APP_DOMAIN + "models";
//       const MODEL_URL = "http://localhost:3000/models";
//       await Promise.all([
//         faceapi?.nets?.ssdMobilenetv1?.loadFromUri(MODEL_URL),
//         faceapi?.nets?.faceLandmark68Net?.loadFromUri(MODEL_URL),
//         faceapi?.nets?.faceRecognitionNet?.loadFromUri(MODEL_URL),
//       ]);
//     };

//     loadModels();
//     return () => {
//       faceapi?.nets?.ssdMobilenetv1?.dispose();
//       faceapi?.nets?.faceLandmark68Net?.dispose();
//       faceapi?.nets?.faceRecognitionNet?.dispose();
//     };
//   }, []);

//   return (
//     <Container
//       fullWidth
//       direction="column"
//       horizontalAlign="center"
//       style={{ gap: "16px" }}
//     >
//       <Text
//         text={
//           !fileBlob
//             ? "Align your face"
//             : isCropped
//               ? "Continue with this photo?"
//               : "Face detected. Click confirm."
//         }
//         appearance="heading-xs"
//       />

//       {!fileBlob && !userSelectedFile && (
//         <>
//           <div style={{ position: "relative", width: "100%" }}>
//             <div
//               style={{ width: "100%", borderRadius: "8px", overflow: "hidden" }}
//             >
//               {/* <Webcam
//                 ref={webcamRef}
//                 audio={false}
//                 screenshotFormat="image/jpeg"
//                 videoConstraints={{
//                   width: 234,
//                   height: 234,
//                   facingMode: "user",
//                 }}
//                 style={{ width: "100%", height: "100%", objectFit: "cover" }}
//                 mirrored={true}
//                 onUserMedia={handleUserMedia}
//               /> */}
//             </div>
//             <ImageCam
//               onCapture={(blob, file) => {
//                 console.log("hello123 camp", file);

//                 profileCapture(file);
//               }}
//               isDetectingFace={isDetectingFace}
//             />
//           </div>
//           {/* <EventRegistrationPrimaryBtn
//             sx={{ width: "100%,", marginTop: "26px" }}
//             onClick={profileCapture}
//             disabled={!isWebcamReady || isDetectingFace}
//             fullWidth
//           >
//             {isDetectingFace ? "Detecting Face..." : "Capture"}
//           </EventRegistrationPrimaryBtn> */}
//         </>
//       )}

//       {!isCropped && previewUrl && (
//         <>
//           <img
//             src={previewUrl}
//             alt="Detected Face"
//             style={{
//               maxWidth: "90%",
//               border: "2px solid #ccc",
//               borderRadius: "12px",
//             }}
//           />
//           <Box sx={{ width: "100%", marginTop: "16px" }}>
//             <Button
//               kind="secondary"
//               onClick={() => setIsCropped(true)}
//               fullWidth
//             >
//               Confirm
//             </Button>
//           </Box>
//         </>
//       )}

//       {isCropped && fileBlob && userSelectedFile && (
//         <>
//           <img
//             src={fileBlob}
//             style={{
//               maxWidth: "264px",
//               borderRadius: "50%",
//               overflow: "hidden",
//               aspectRatio: 1,
//               objectFit: "cover",
//             }}
//             draggable={false}
//           />
//           <Box
//             sx={{
//               display: "flex",
//               flexWrap: "wrap",
//               gap: "16px",
//               flexDirection: "row",
//               justifyContent: "center",
//               marginTop: "26px",
//               width: "100%",
//             }}
//           >
//             <Button
//               kind="primary"
//               onClick={handleGetFaceCount}
//               disabled={isProfileUpdating || isGetFaceCounting || btnDisable}
//               fullWidth
//             >
//               Confirm
//             </Button>
//             <Button
//               kind="secondary"
//               fullWidth
//               onClick={() => {
//                 setFileBlod(null);
//                 setUserSelectedFile(null);
//                 setIsWebcamReady(false);
//                 setPreviewUrl(null);
//                 setIsCropped(false);
//               }}
//             >
//               Retake
//             </Button>
//           </Box>
//         </>
//       )}
//     </Container>
//   );
// };

// export default Selfie;

import { Button, Container, Notifications, Text } from "@jds/core";
import { useCallback, useEffect, useRef, useState } from "react";
import { Alert, Box, Snackbar } from "@mui/material";
import Webcam from "react-webcam";

import EventRegistrationPrimaryBtn from "../EventRegistrationPrimaryBtn/EventRegistrationPrimaryBtn";
import EventRegistrationSecondaryBtn from "../EventRegistrationSecondaryBtn/EventRegistrationSecondaryBtn";
import useApiHttp from "../../../hooks/use-http";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  setSelfieModalClose,
  setUserClusterApiTrigger,
} from "../../../store/state-slices/userRegistration";

import * as faceapi from "face-api.js";
import ImageCam from "../ImageCam/ImageCam";
import {
  disposeFaceApiModels,
  loadFaceApiModels,
} from "../../../util/faceApiLoader";

const detectAndCropLargestFace = async (imageFile) => {
  const img = await faceapi.bufferToImage(imageFile);

  // Draw the image onto a canvas
  const canvas = document.createElement("canvas");
  canvas.width = img.width;
  canvas.height = img.height;
  const ctx = canvas.getContext("2d");
  ctx.drawImage(img, 0, 0);

  // Detect faces with landmarks and descriptors
  const detections = await faceapi
    .detectAllFaces(canvas)
    .withFaceLandmarks()
    .withFaceDescriptors();

  if (!detections.length) {
    throw new Error("No face detected.");
  }

  // Find the largest face
  const largest = detections.reduce((max, det) => {
    const area = det.detection.box.width * det.detection.box.height;
    const maxArea = max.detection.box.width * max.detection.box.height;
    return area > maxArea ? det : max;
  });

  const { x, y, width, height } = largest.detection.box;

  // Adjusted padding
  const sidePadding = Math.floor(width * 0.2); // Increase width by 30% on each side
  const topPadding = Math.floor(height * 0.5); // Increase height above face for hair
  const bottomPadding = Math.floor(height * 0.2); // Slight bottom padding

  const paddedX = Math.max(0, x - sidePadding);
  const paddedY = Math.max(0, y - topPadding);
  const paddedWidth = Math.min(canvas.width - paddedX, width + 2 * sidePadding);
  const paddedHeight = Math.min(
    canvas.height - paddedY,
    height + topPadding + bottomPadding
  );

  // Optional: Create a preview with a red rectangle
  const previewCanvas = document.createElement("canvas");
  previewCanvas.width = canvas.width;
  previewCanvas.height = canvas.height;
  const previewCtx = previewCanvas.getContext("2d");
  previewCtx.drawImage(img, 0, 0);
  previewCtx.strokeStyle = "yellow";
  previewCtx.lineWidth = 3;
  previewCtx.strokeRect(paddedX, paddedY, paddedWidth, paddedHeight);

  const previewUrl = previewCanvas.toDataURL();

  // Create the cropped image with expanded bounding box
  const faceCanvas = document.createElement("canvas");
  faceCanvas.width = paddedWidth;
  faceCanvas.height = paddedHeight;
  const faceCtx = faceCanvas.getContext("2d");
  faceCtx.drawImage(
    img,
    paddedX,
    paddedY,
    paddedWidth,
    paddedHeight,
    0,
    0,
    paddedWidth,
    paddedHeight
  );

  // Return result
  return new Promise((resolve) => {
    faceCanvas.toBlob((blob) => {
      const croppedFile = new File([blob], imageFile.name, {
        type: imageFile.type,
      });
      resolve({
        blobUrl: URL.createObjectURL(blob),
        file: croppedFile,
        previewUrl,
      });
    }, imageFile.type);
  });
};

const Selfie = ({
  setToastOpen = () => { },
  setToastInfo = () => { },
  isGetFile = false,
  getFile = () => { },
}) => {
  const webcamRef = useRef(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [fileBlob, setFileBlod] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [facesApiLoaded, setFacesApiLoaded] = useState(false);

  const [userSelectedFile, setUserSelectedFile] = useState(null);
  const [isWebcamReady, setIsWebcamReady] = useState(false);
  const [btnDisable, setBtnDisable] = useState(false);
  const [isDetectingFace, setIsDetectingFace] = useState(false);
  const [isCropped, setIsCropped] = useState(false);
  const loginDetails = useSelector((state) => state.auth.loginDetails);

  const { sendRequest: updateProfile, isLoading: isProfileUpdating } =
    useApiHttp();
  const { sendRequest: getFaceCount, isLoading: isGetFaceCounting } =
    useApiHttp();

  const capturePhoto = useCallback(() => {
    const imageSrc = webcamRef.current.getScreenshot();
    let currentDate = new Date();
    let dateTimeString =
      currentDate.getFullYear() +
      String(currentDate.getMonth() + 1).padStart(2, "0") +
      String(currentDate.getDate()).padStart(2, "0") +
      "T" +
      String(currentDate.getHours()).padStart(2, "0") +
      String(currentDate.getMinutes()).padStart(2, "0") +
      String(currentDate.getSeconds()).padStart(2, "0") +
      ".jpg";
    return dataURItoFile(imageSrc, dateTimeString);
  }, [webcamRef]);

  function dataURItoFile(dataURI, filename) {
    var byteString = atob(dataURI.split(",")[1]);
    var mimeString = dataURI.split(",")[0].split(":")[1].split(";")[0];
    var ia = new Uint8Array(byteString.length);
    for (var i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }
    return new File([ia], filename, { type: mimeString });
  }

  async function profileCapture(imgFile) {
    try {
      setIsDetectingFace(true);
      const { blobUrl, file, previewUrl } = await detectAndCropLargestFace(
        imgFile
      );
      setFileBlod(blobUrl);
      setUserSelectedFile(file);
      setPreviewUrl(previewUrl);
      setIsCropped(false);
    } catch (err) {
      // Notifications.toast.error({
      //   id: "face-detection-failure",
      //   title: err.message || "Unable to detect face. Try again.",
      // });
      setToastInfo({
        msg: err.message || "Unable to detect face. Try again.",
        type: "error",
      });
      setToastOpen(true);
    } finally {
      setIsDetectingFace(false);
    }
  }

  const handleUserMedia = () => setIsWebcamReady(true);

  const resetSelfie = () => {
    setFileBlod(null);
    setUserSelectedFile(null);
    setIsWebcamReady(false);
    setPreviewUrl(null);
    setIsCropped(false);
  };

  const handleUpdateSelfie = () => {
    if (!userSelectedFile) return;
    const userProfile = new FormData();
    userProfile.append("profilePicture", userSelectedFile);
    updateProfile(
      {
        base: "AUTH",
        url: `profile`,
        method: "PUT",
        body: userProfile,
        formData: true,
      },
      null,
      (data) => {
        setTimeout(() => {
          // Notifications.toast.success({
          //   id: "update-profile",
          //   title: data?.message,
          // });
          setToastInfo({
            msg: data?.message,
            type: "success",
          });
          setToastOpen(true);
          localStorage.profilePictureThumbnail =
            data?.data?.profilePictureThumbnailUrl;
          dispatch(setSelfieModalClose(true));
          dispatch(setUserClusterApiTrigger());
          navigate(`/user-registered/photos?eventId=${loginDetails?.eventId}`);
          setBtnDisable(false);

          resetSelfie();
        }, 2000);
      },
      (err, data) => {
        // Notifications.toast.error({
        //   id: "update-profile",
        //   title: data?.message,
        // });
        setToastInfo({
          msg: data?.message,
          type: "error",
        });
        setToastOpen(true);
        setBtnDisable(false);
      }
    );
  };

  const handleGetFaceCount = () => {
    if (!userSelectedFile) return;
    const userProfile = new FormData();
    userProfile.append("uploadFile", userSelectedFile);
    getFaceCount(
      {
        base: "MEDIA",
        url: `face/get-face-count`,
        method: "POST",
        body: userProfile,
        formData: true,
      },
      null,
      () => {
        if (isGetFile) {
          getFile(userSelectedFile);
        } else {
          setBtnDisable(true);
          handleUpdateSelfie();
        }
      },
      (err, data) => {
        Notifications.toast.error({
          id: "get-face-count-error",
          title: data?.message,
        });

        setToastInfo({
          msg: data?.message,
          type: "error",
        });
        setToastOpen(true);
      }
    );
  };
  useEffect(() => {
    let isMounted = true;

    const loadModels = async () => {
      try {
        const MODEL_URL = process.env.REACT_APP_DOMAIN + "models";
        // const MODEL_URL = "http://localhost:3000/models";
        await loadFaceApiModels(MODEL_URL);
        if (isMounted) {
          setFacesApiLoaded(true);
        }
      } catch (err) {
        console.error("❌ Error loading face-api models:", err);
      }
    };

    loadModels();

    return () => {
      isMounted = false;
      disposeFaceApiModels();
    };
  }, []);

  return (
    <Container
      fullWidth
      direction="column"
      horizontalAlign="center"
      style={{ gap: "16px" }}
    >
      <Text
        text={
          !fileBlob
            ? "Align your face"
            : isCropped
              ? "Continue with this photo?"
              : "Face detected. Click confirm."
        }
        appearance="heading-xs"
      />

      {!fileBlob && !userSelectedFile && (
        <>
          <div style={{ position: "relative", width: "100%" }}>
            <div
              style={{ width: "100%", borderRadius: "8px", overflow: "hidden" }}
            >
              {/* <Webcam
                ref={webcamRef}
                audio={false}
                screenshotFormat="image/jpeg"
                videoConstraints={{
                  width: 234,
                  height: 234,
                  facingMode: "user",
                }}
                style={{ width: "100%", height: "100%", objectFit: "cover" }}
                mirrored={true}
                onUserMedia={handleUserMedia}
              /> */}
            </div>
            {facesApiLoaded ? (
              <ImageCam
                onCapture={(blob, file) => {
                  console.log("hello123 camp", file);

                  profileCapture(file);
                }}
                isDetectingFace={isDetectingFace}
                modelsAlreadyLoaded={true}
              />
            ) : (
              <>
                <Container fullWidth horizontalAlign="center">
                  <Text text="Fetching details..." />
                </Container>
              </>
            )}
          </div>
          {/* <EventRegistrationPrimaryBtn
            sx={{ width: "100%,", marginTop: "26px" }}
            onClick={profileCapture}
            disabled={!isWebcamReady || isDetectingFace}
            fullWidth
          >
            {isDetectingFace ? "Detecting Face..." : "Capture"}
          </EventRegistrationPrimaryBtn> */}
        </>
      )}

      {!isCropped && previewUrl && (
        <>
          <img
            src={previewUrl}
            alt="Detected Face"
            style={{
              maxWidth: "90%",
              border: "2px solid #ccc",
              borderRadius: "12px",
            }}
          />
          <Box sx={{ width: "100%", marginTop: "16px" }}>
            <Button
              kind="secondary"
              onClick={() => setIsCropped(true)}
              fullWidth
            >
              Confirm
            </Button>
          </Box>
        </>
      )}

      {isCropped && fileBlob && userSelectedFile && (
        <>
          <img
            src={fileBlob}
            style={{
              maxWidth: "264px",
              borderRadius: "50%",
              overflow: "hidden",
              aspectRatio: 1,
              objectFit: "cover",
            }}
            draggable={false}
          />
          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              gap: "16px",
              flexDirection: "row",
              justifyContent: "center",
              marginTop: "26px",
              width: "100%",
            }}
          >
            <Button
              kind="primary"
              onClick={handleGetFaceCount}
              disabled={isProfileUpdating || isGetFaceCounting || btnDisable}
              fullWidth
            >
              Confirm
            </Button>
            <Button
              kind="secondary"
              fullWidth
              onClick={() => {
                setFileBlod(null);
                setUserSelectedFile(null);
                setIsWebcamReady(false);
                setPreviewUrl(null);
                setIsCropped(false);
              }}
            >
              Retake
            </Button>
          </Box>
        </>
      )}
    </Container>
  );
};

export default Selfie;